const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const pixelsPerFrame = isMobile ? 10 : 10;

// Loop through each product can wrapper dynamically
document.querySelectorAll('.can-wrapper').forEach((wrapper, index) => {
  const imageUrls = window.theme.footer_animation_frames[index] || window.theme.footer_animation_frames[0]; 
  // This assumes window.theme.footer_animation_frames is an array of arrays, 
  // e.g. [ [frames for can1], [frames for can2] ]

  if (!imageUrls || !imageUrls.length) return;

  const totalFrames = imageUrls.length;
  let currentFrame = 0;
  let isDragging = false;
  let startX = 0;
  let accumulatedDeltaX = 0;

  const placeholderImage = wrapper.querySelector('#placeholder-image');
  const svgContainer = wrapper.querySelector('#svg-container');
  const canvas = wrapper.querySelector('#canvas');
  const imageContainer = wrapper.querySelector('#image-container');
  const rotatingImage = wrapper.querySelector('#rotating-image');

  placeholderImage.src = imageUrls[0];

  if (isMobile) {
    // ----- MOBILE LOGIC -----
    placeholderImage.style.display = 'block';
    imageContainer.style.display = 'none';
    rotatingImage.src = imageUrls[0];

    const images = imageUrls.map(url => {
      const img = new Image();
      img.src = url;
      return img;
    });

    Promise.all(images.map(img => new Promise(resolve => img.onload = resolve))).then(() => {
      placeholderImage.style.display = 'none';
      imageContainer.style.display = 'block';
    });

    function handleSwipe(pageX) {
      const deltaX = pageX - startX;
      accumulatedDeltaX += deltaX;
      startX = pageX;

      const frameChange = Math.floor(accumulatedDeltaX / pixelsPerFrame);
      if (frameChange !== 0) {
        accumulatedDeltaX = 0;
        currentFrame = (currentFrame - frameChange) % totalFrames;
        if (currentFrame < 0) currentFrame = totalFrames + currentFrame;
        rotatingImage.src = imageUrls[currentFrame]; // Update image source
      }
    }

    rotatingImage.addEventListener('touchstart', e => {
      isDragging = true;
      startX = e.touches[0].pageX;
      accumulatedDeltaX = 0;
    });

    rotatingImage.addEventListener('touchmove', e => {
      if (!isDragging) return;
      handleSwipe(e.touches[0].pageX);
    });

    rotatingImage.addEventListener('touchend', () => (isDragging = false));

  } else {
    // ----- DESKTOP LOGIC -----
    const ctx = canvas.getContext('2d');
    const images = [];

    svgContainer.style.display = 'none';

    function preloadImages() {
      return Promise.all(
        imageUrls.map(url => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(img);
            img.onerror = () => reject(`Failed to load image: ${url}`);
            images.push(img);
          });
        })
      );
    }

    function drawFrame() {
      if (images[currentFrame]) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(images[currentFrame], 0, 0, canvas.width, canvas.height);
      }
    }

    function handleDrag(pageX) {
      const deltaX = pageX - startX;
      accumulatedDeltaX += deltaX;
      startX = pageX;

      const frameChange = Math.floor(accumulatedDeltaX / pixelsPerFrame);
      if (frameChange !== 0) {
        accumulatedDeltaX = 0;
        currentFrame = (currentFrame - frameChange) % totalFrames;
        if (currentFrame < 0) currentFrame = totalFrames + currentFrame;
        drawFrame(); // Update canvas with new frame
      }
    }

    canvas.addEventListener('mousedown', e => {
      isDragging = true;
      startX = e.pageX;
      accumulatedDeltaX = 0;
    });

    canvas.addEventListener('mousemove', e => {
      if (!isDragging) return;
      handleDrag(e.pageX);
    });

    canvas.addEventListener('mouseup', () => (isDragging = false));
    canvas.addEventListener('mouseleave', () => (isDragging = false));

    preloadImages()
      .then(() => {
        placeholderImage.style.display = 'none';
        svgContainer.style.display = 'block';
        drawFrame();
      })
      .catch(console.error);
  }

  if(window.innerWidth > 768){
    svgContainer.addEventListener('mouseover', function() {
      this.parentElement.querySelector('.footer-shop-btn').classList.add('is-visible');
    });
  }
});
